import Vue from 'vue';
import Router from 'vue-router';

export default () => {
  Vue.use(Router);

  const router = new Router({
    mode: 'history',
    base: '/ics/property',
    routes: [
      {
        path: '/history',
        name: 'history',
        component: () => import('./history'),
      },
      {
        path: '/favorite',
        name: 'bookmark',
        component: () => import('./bookmark'),
      },
    ],
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
  });

  return router;
};
